import { render, staticRenderFns } from "./yuyue.vue?vue&type=template&id=0be4f266&scoped=true"
import script from "./yuyue.vue?vue&type=script&lang=js"
export * from "./yuyue.vue?vue&type=script&lang=js"
import style0 from "./yuyue.vue?vue&type=style&index=0&id=0be4f266&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4f266",
  null
  
)

export default component.exports